<template>
  <div style="min-height: 750px;">
    <b-row style="margin: 3px;">
      <b-col sm="12" lg="6">
        <template v-if="d_loading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </template>
        <template v-else>
          <template v-if="p_userShopBundleClientID">
            <div v-if="p_userShopBundleClientID">
              Client ID: <small> {{ p_userShopBundleClientID }} </small> 
            </div>
            <div v-if="d_userShopBundleLayerId">
              Key: <small> {{ 'L' + d_userShopBundleLayerId + '_' + d_userShopBundleWdmrId }} </small> 
            </div>
          </template>
          <template v-else>
            <strong>
                  {{ StoreLangTranslation.data['new_data'][StoreLang] }}
            </strong>
          </template>
        </template>

      </b-col>
      <b-col sm="12" lg="6" style="text-align: right;">
        <template v-if="!d_loading">
          <template v-if="d_saveLoading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-else>
            <b-button variant="outline-success" @click="f_userShopBundleRecord()">
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </template>
        </template>
      </b-col>
    </b-row>
    <b-row v-if="!d_loading && d_userShopBundleWdm" style="overflow-x: hidden; overflow-y: auto; height: 750px;">
      <b-col sm="12" lg="12">

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_package_general_features'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['package_general_features'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;">

            </b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_package_general_features">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-textarea class="form-control" rows="5" v-model="d_userShopBundleData.bundle_name[lang.label]"></b-form-textarea>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="12">
                <strong> Agreement Copy </strong>
              </b-col>
            </b-row>
            <b-row v-if="!d_agreementListLoading" style="margin: 3px;">
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_selectedAgreementCopy">
                  <option v-for="(op, op_index) in d_bundleHasAgreementList" :value="op.client_id">
                    {{ op.name[StoreLang] }}
                  </option>
                </select>
              </b-col>
              <b-col sm="12" lg="4">
                <b-button :disabled="!d_selectedAgreementCopy" @click="f_copyAgreement()">
                  {{ StoreLangTranslation.data['copy'][StoreLang] }}
                </b-button>
              </b-col>
            </b-row>
            <template v-else>
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.status">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['0'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['19']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.bundle_type">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['19'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <template v-if="d_userShopBundleData.bundle_type == '5'">
              <b-row style="margin: 3px;">
                <b-col sm="12" lg="4">
                  <strong>{{ d_userShopBundleWdm['0']['parameters']['75']['name']['translation'][StoreLang] }}</strong>
                </b-col>
                <b-col sm="12" lg="8">
                  <b-form-input type="text" v-model="d_userShopBundleData.institutional_number_per_user"></b-form-input>
                </b-col>
              </b-row>
              <hr>
            </template>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>
                  {{ StoreLangTranslation.data['package_group_already_exist'][StoreLang] }}
                </strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-select v-model="d_selectBundleGroup" @change="f_getPackageGroupFrontendList()">
                  <option value="" selected>-</option>
                  <option v-for="group_item in d_shopBundleGroupList" :value="group_item" >
                    {{ group_item['lang'][StoreLang] }}
                  </option>
                </b-form-select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['10']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.bundle_group[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="12">
                <strong>{{ StoreLangTranslation.data['which_frontends_display_this_package_group'][StoreLang] }}</strong>
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(frd_package_group, frd_package_group_index) in d_frontendPackageGroupList">
              <b-col sm="12" lg="12">
                <b-form-checkbox v-model="d_PackageGroupFrontendList[frd_package_group.client_id]" @input="$forceUpdate()"> {{ frd_package_group.frontend_name }} </b-form-checkbox>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['77']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-input type="date" v-model="d_userShopBundleData.bundle_date"></b-form-input>
              </b-col>
            </b-row>
            <hr>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_automatic_product_assignment_settings_during_login'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['automatic_product_assignment_settings_during_login'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_automatic_product_assignment_settings_during_login">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['24']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.assigned_user_list[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['25']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <b-form-input type="number" v-model="d_userShopBundleData.max_assigned_count"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['26']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <span>{{ d_userShopBundleData.used_assigned_count }}</span>
              </b-col>
            </b-row>
            <hr>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_shop_view_settings'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['shop_view_settings'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_shop_view_settings">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['21']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.can_customer_add_to_shopcart">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['21'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['12']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.available_soon">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['12'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['20']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.in_store_visibility">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['20'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['23']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.ordered_use">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['23'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['13']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.prices_on_the_screen">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['13'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_organization_settings'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['organization_settings'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_organization_settings">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['4']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.organization_id[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.organization_name[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['6']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.organization_user_id[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['7']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.organization_username[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['17']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.organization_token[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['8']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.priority">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['8'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['9']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.task_type">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['9'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_payment_period'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['payment_period'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_payment_period">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['14']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.expiration_time_type">
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['14'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['15']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.expiration_time_value[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['16']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
              </b-col>
            </b-row>
            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
              <b-col sm="12" lg="1">
                {{ lang.label }}
              </b-col>
              <b-col sm="12" lg="11">
                <b-form-input type="text" v-model="d_userShopBundleData.expiration_time_value_by_text[lang.label]"></b-form-input>
              </b-col>
            </b-row>
            <hr>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_product_settings'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['dataset_product_settings'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_dataset_product_settings">
          <b-card-body>
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="4">
                <strong>{{ d_userShopBundleWdm['0']['parameters']['56']['name']['translation'][StoreLang] }}</strong>
              </b-col>
              <b-col sm="12" lg="8">
                <select class="form-control" v-model="d_userShopBundleData.is_dataset">
                  <option value="" selected>-</option>
                  <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['56'].options" :value="op.value">
                    {{ op.translation[StoreLang] }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <hr>
            <template v-if="d_userShopBundleData.is_dataset == '1'">
              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_general_information'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_general_information'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;">
                  </b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_general_information">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ f_domainGet() + '/dataset?did=' + d_userShopBundleWdmrId }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                        <a :href="'/dataset?did=' + d_userShopBundleWdmrId" target="_blank">did link</a>
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['46']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.licence_type">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['46'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['51']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.which_one_best_describes_your_reason_for_sharing_dataset">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['51'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['27']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-textarea v-model="d_userShopBundleData.package_creator_user"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['28']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-textarea v-model="d_userShopBundleData.dataset_creator_note"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                </b-card-body>
              </b-collapse>
              
              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_contact_information'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_contact_information'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_contact_information">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['29']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.communication_with_the_user_requesting_the_dataset">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['29'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <template v-if="d_userShopBundleData.communication_with_the_user_requesting_the_dataset == '1'">
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['30']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-textarea v-model="d_userShopBundleData.dataset_creator_phone"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['31']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-textarea v-model="d_userShopBundleData.dataset_creator_mail"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['32']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <b-form-textarea type="text" v-model="d_userShopBundleData.dataset_creator_note_to_requester[lang.label]"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                  </template>
                </b-card-body>
              </b-collapse>

              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_cancellation_status'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_cancellation_status'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_cancellation_status">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['33']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.reason_for_cancellation">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['33'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['34']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-textarea v-model="d_userShopBundleData.reason_for_cancellation_note"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                </b-card-body>
              </b-collapse>

              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_features'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_features'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_features">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['39']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-row>
                        <b-col cols="12">
                          <b-button :class="{ active: d_inputEditorMode === 'html' }"  variant="outline-secondary" @click="f_changeInputEditorMode('html')" style="font-size: 14px; margin-right: 2px;">{{ StoreLangTranslation.data['html_editor'][StoreLang] }}</b-button>
                          <b-button :class="{ active: d_inputEditorMode === 'text' }"  variant="outline-secondary" @click="f_changeInputEditorMode('text', d_userShopBundleData)" style="font-size: 14px;">{{ StoreLangTranslation.data['text_editor'][StoreLang] }}</b-button>
                        </b-col>
                      </b-row>
                      <template v-if="d_userShopBundleData.about_dataset && d_userShopBundleData.about_dataset[lang.label]">
                        <template v-if="d_inputEditorMode == 'text'">
                          <b-textarea v-model="d_userShopBundleData.about_dataset[lang.label]" style="height: 300px;"></b-textarea>
                        </template>
                        <template v-else-if="d_inputEditorMode == 'html'">
                          <html-editor :key="lang_index" :p_html_text="d_userShopBundleData.about_dataset[lang.label]" :p_htmlElementId="'website_html_edit_about_dataset_' + lang.label"></html-editor>
                        </template>
                      </template>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['38']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <!-- <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-form-textarea type="text" v-model="d_userShopBundleData.various_variables[lang.label]"></b-form-textarea>
                    </b-col>
                  </b-row> -->

                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-row>
                        <b-col cols="12">
                          <b-button :class="{ active: d_inputEditorMode === 'html' }"  variant="outline-secondary" @click="f_changeInputEditorMode('html')" style="font-size: 14px; margin-right: 2px;">{{ StoreLangTranslation.data['html_editor'][StoreLang] }}</b-button>
                          <b-button :class="{ active: d_inputEditorMode === 'text' }"  variant="outline-secondary" @click="f_changeInputEditorMode('text', d_userShopBundleData)" style="font-size: 14px;">{{ StoreLangTranslation.data['text_editor'][StoreLang] }}</b-button>
                        </b-col>
                      </b-row>
                      <template v-if="d_userShopBundleData.various_variables && d_userShopBundleData.various_variables[lang.label]">
                        <template v-if="d_inputEditorMode == 'text'">
                          <b-textarea v-model="d_userShopBundleData.various_variables[lang.label]" style="height: 300px;"></b-textarea>
                        </template>
                        <template v-else-if="d_inputEditorMode == 'html'">
                          <html-editor :key="lang_index" :p_html_text="d_userShopBundleData.various_variables[lang.label]" :p_htmlElementId="'website_html_edit_various_variables_' + lang.label"></html-editor>
                        </template>
                      </template>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['35']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.demo_dataset">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['35'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['36']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-input type="number" v-model="d_userShopBundleData.row_count"></b-form-input>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['37']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-input type="number" v-model="d_userShopBundleData.column_count"></b-form-input>
                    </b-col>
                  </b-row>
                  <hr>
                </b-card-body>
              </b-collapse>

              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_subscriber_features'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_subscriber_features'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_subscriber_features">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['40']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.dataset_usage_type">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['40'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <template v-if="d_userShopBundleData.dataset_usage_type == '1'">
                    <hr>
                    <b-row style="margin: 3px;">
                  
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['52']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <b-form-textarea type="text" v-model="d_userShopBundleData.visiting_research_institution_request_text[lang.label]"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                  </template>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['41']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.special_acknowledgement_request_status">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['41'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <div v-if="d_userShopBundleData.special_acknowledgement_request_status == '1'">
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['42']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="11">
                        <b-form-textarea type="text" v-model="d_userShopBundleData.special_acknowledgement_text[lang.label]"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                  </div>
                </b-card-body>
              </b-collapse>

              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_dataset_author_and_article_information'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['dataset_author_and_article_information'][StoreLang] }}
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_dataset_author_and_article_information">
                <b-card-body>
                  <b-row style="margin: 3px; margin-bottom: 10px;">
                    <b-col sm="12" lg="4">
                      <strong>
                        {{ d_userShopBundleWdm['0']['parameters']['57']['name']['translation'][StoreLang] }}
                      </strong>
                    </b-col>

                    <b-col sm="12" lg="8">
                      <button class="btn btn-success" @click="f_addResearcher()">
                        +
                      </button>
                    </b-col>
                  </b-row>

                  <b-row style="margin: 3px; margin-bottom: 10px;">
                    <b-col sm="12" lg="4">
                      <strong>
                        {{ StoreLangTranslation.data['author_search_by_mail_and_add'][StoreLang] }}
                      </strong>
                    </b-col>

                    <b-col sm="12" lg="6">
                        <b-form-textarea type="text" v-model="d_searchAuthorMails" :placeholder="StoreLangTranslation.data['please_add_mails_with_commas'][StoreLang]"></b-form-textarea>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <template v-if="d_authorSearchLoading">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                      </template>
                      <template v-else>
                        <button class="btn btn-primary" @click="f_authorSearchByMailAndAdd(d_userShopBundleData.author_list)">
                          <i class="fa fa-search-plus"></i>
                        </button>
                      </template>
                    </b-col>
                  </b-row>

                  <div v-for="(author_item, author_index) in d_userShopBundleData.author_list" :key="'author_' + author_index">

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                        <button class="btn btn-danger" @click="f_removeResearcher(author_index)">
                          <i class="fa fa-trash-o"></i>
                        </button>
                        <button class="btn btn-warning" style="margin-left: 5px;" @click="f_openAuthorEditModal(author_item)">
                          <i class="fa fa-pencil"></i>
                        </button>
                        <button class="btn btn-info" style="margin-left: 5px;" @click="f_copyResearcher(author_index)">
                          <i class="fa fa-clone"></i>
                        </button>
                        <br/>
                        <button class="btn btn-secondary" style="margin-left: 5px;" @click="f_moveResearcher(author_index, 'up')">
                          <i class="fa fa-arrow-up"></i>
                        </button>
                        <button class="btn btn-secondary" style="margin-left: 5px;" @click="f_moveResearcher(author_index, 'down')">
                          <i class="fa fa-arrow-down"></i>
                        </button>
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['60']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-input
                          class="form-control"
                          v-model="author_item.title">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['58']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-input
                          class="form-control"
                          v-model="author_item.firstname">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['59']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-input
                          class="form-control"
                          v-model="author_item.lastname">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['61']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-input
                          class="form-control"
                          v-model="author_item.mail">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['62']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                      </b-col>
                    </b-row>
                    <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="1">
                        {{ lang.label }}
                      </b-col>
                      <b-col sm="12" lg="9">
                        <b-form-textarea type="text" v-model="author_item.institution[lang.label]"></b-form-textarea>
                      </b-col>
                    </b-row>

                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="2">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['63']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-input
                          class="form-control"
                          v-model="author_item.orcid_id">
                        </b-form-input>
                      </b-col>
                    </b-row>

                    <b-row v-if="" style="margin: 3px;">
                      <b-col sm="12" lg="2">
                      </b-col>
                      <b-col sm="12" lg="10">
                        <hr/>
                      </b-col>
                    </b-row>
                  </div>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['43']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-form-textarea type="text" v-model="d_userShopBundleData.methodologies_and_analyses_to_be_excluded[lang.label]"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['44']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-input type="number" v-model="d_userShopBundleData.data_collection_center_count"></b-form-input>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['45']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-form-textarea type="text" v-model="d_userShopBundleData.data_collection_centers[lang.label]"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['47']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="d_userShopBundleData.dataset_publication_status_in_an_article">
                        <option value="" selected>-</option>
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['47'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <div v-if="d_userShopBundleData.dataset_publication_status_in_an_article == '1'">
                    <!-- <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-textarea v-model="d_userShopBundleData.journal_name"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-textarea v-model="d_userShopBundleData.article_title"></b-form-textarea>
                      </b-col>
                    </b-row>
                    <hr>
                    <b-row style="margin: 3px;">
                      <b-col sm="12" lg="4">
                        <strong>{{ d_userShopBundleWdm['0']['parameters']['50']['name']['translation'][StoreLang] }}</strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <b-form-textarea v-model="d_userShopBundleData.link"></b-form-textarea>
                      </b-col>
                    </b-row> -->


                


                    <b-row style="margin: 3px; margin-bottom: 10px;">
                      <b-col sm="12" lg="4">
                        <strong>
                          {{ d_userShopBundleWdm['0']['parameters']['64']['name']['translation'][StoreLang] }}
                        </strong>
                      </b-col>
                      <b-col sm="12" lg="8">
                        <button class="btn btn-success" @click="f_addArticle()">
                          +
                        </button>
                      </b-col>
                    </b-row>

                    <div v-for="(article_item, article_index) in d_userShopBundleData.article_list" :key="'article_' + article_index">

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                          <button class="btn btn-danger" @click="f_removeArticle(article_index)">
                            <i class="fa fa-trash-o"></i>
                          </button>
                          <button class="btn btn-info" style="margin-left: 5px;" @click="f_copyArticle(article_index)">
                            <i class="fa fa-clone"></i>
                          </button>
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['48']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input
                            class="form-control"
                            v-model="article_item.journal_name">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['65']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <select class="form-control" v-model="article_item.article_status">
                            <option value="" selected>-</option>
                            <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['64']['parameters']['65'].options" :value="op.value">
                              {{ op.translation[StoreLang] }}
                            </option>
                          </select>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['49']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input
                            class="form-control"
                            v-model="article_item.article_title">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['50']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input
                            class="form-control"
                            v-model="article_item.article_link">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['73']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input
                            class="form-control"
                            type="date"
                            v-model="article_item.article_date">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['78']['name']['translation'][StoreLang] }}</strong>
                          <!-- <strong>metodoloji</strong> -->
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-textarea
                            class="form-control"
                            v-model="article_item.research_methodology">
                          </b-form-textarea>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['74']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">
                          <b-form-input
                            class="form-control"
                            v-model="article_item.article_creator">
                          </b-form-input>
                        </b-col>
                      </b-row>

                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['name']['translation'][StoreLang] }}</strong>
                        </b-col>
                        <b-col sm="12" lg="8">

                          <!-- <b-row style="margin: 3px; margin-bottom: 10px;"> -->
                            <!-- <b-col sm="12" lg="4">
                              <strong>
                                {{ d_userShopBundleWdm['0']['parameters']['64']['name']['translation'][StoreLang] }}
                              </strong> -->

                              <!-- <i id="popover-target-researcher-list" class="fa fa-info-circle"
                                 style="color:#2492FF;margin-left:5px;display:inline-block;" tabindex="0"></i>

                              <b-popover target="popover-target-researcher-list" triggers="hover focus" placement="right" container="body">
                                <template #title>{{ StoreLangTranslation.data['info'][StoreLang] }}</template>
                                {{ StoreLangTranslation.data['info_author_list'][StoreLang] }}
                              </b-popover> -->
                            <!-- </b-col> -->

                            <!-- <b-col sm="12" lg="8"> -->
                              <button class="btn btn-success" @click="f_addArticleAuthor(article_index)">
                                +
                              </button>
                        </b-col>
                      </b-row>
                      <b-row style="margin: 3px; margin-bottom: 10px;">
                        <b-col sm="12" lg="4">
                          <strong>
                            {{ StoreLangTranslation.data['author_search_by_mail_and_add'][StoreLang] }}
                          </strong>
                        </b-col>

                        <b-col sm="12" lg="6">
                            <b-form-textarea type="text" v-model="d_searchAuthorMails" :placeholder="StoreLangTranslation.data['please_add_mails_with_commas'][StoreLang]"></b-form-textarea>
                        </b-col>
                        <b-col sm="12" lg="2">
                          <template v-if="d_authorSearchLoading">
                            <b-spinner variant="primary" label="Spinning"></b-spinner>
                          </template>
                          <template v-else>
                            <button class="btn btn-primary" @click="f_authorSearchByMailAndAdd(d_userShopBundleData.article_list[article_index].article_authors)">
                              <i class="fa fa-search-plus"></i>
                            </button>
                          </template>
                        </b-col>
                      </b-row>
                      <b-row style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="10">
                          <div v-for="(article_author_item, article_author_index) in d_userShopBundleData.article_list[article_index].article_authors" :key="'article_author_' + article_author_index">

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                                <button class="btn btn-danger" @click="f_removeArticleAuthor(article_index, article_author_index)">
                                  <i class="fa fa-trash-o"></i>
                                </button>
                                <button class="btn btn-warning" style="margin-left: 5px;" @click="f_openAuthorEditModal(article_author_item)">
                                  <i class="fa fa-pencil"></i>
                                </button>
                                <button class="btn btn-info" style="margin-left: 5px;" @click="f_copyArticleAuthor(article_index, article_author_index)">
                                  <i class="fa fa-clone"></i>
                                </button>
                                <br/>
                                <button class="btn btn-secondary" style="margin-left: 5px;" @click="f_moveArticleAuthor(article_index, article_author_index, 'up')":disabled="article_author_index == 0">
                                  <i class="fa fa-arrow-up"></i>
                                </button>
                                <button class="btn btn-secondary" style="margin-left: 5px;" @click="f_moveArticleAuthor(article_index, article_author_index, 'down')" :disabled="article_author_index == d_userShopBundleData.article_list[article_index].article_authors.length - 1">
                                  <i class="fa fa-arrow-down"></i>
                                </button>
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['69']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.title">
                                </b-form-input>
                              </b-col>
                            </b-row>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['67']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.firstname">
                                </b-form-input>
                              </b-col>
                            </b-row>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['68']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.lastname">
                                </b-form-input>
                              </b-col>
                            </b-row>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['70']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.mail">
                                </b-form-input>
                              </b-col>
                            </b-row>

                            <!-- <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['71']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.institution">
                                </b-form-input>
                              </b-col>
                            </b-row> -->

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['71']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                            </b-row>
                            <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="1">
                                {{ lang.label }}
                              </b-col>
                              <b-col sm="12" lg="9">
                                <b-form-textarea type="text" v-model="article_author_item.institution[lang.label]"></b-form-textarea>
                              </b-col>
                            </b-row>

                            <b-row style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="2">
                                <strong>{{ d_userShopBundleWdm['0']['parameters']['64']['parameters']['66']['parameters']['72']['name']['translation'][StoreLang] }}</strong>
                              </b-col>
                              <b-col sm="12" lg="8">
                                <b-form-input
                                  class="form-control"
                                  v-model="article_author_item.orcid_id">
                                </b-form-input>
                              </b-col>
                            </b-row>

                            <b-row v-if="" style="margin: 3px;">
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col sm="12" lg="10">
                                <hr/>
                              </b-col>
                            </b-row>
                          </div>

                        </b-col>
                      </b-row>

                      <b-row v-if="" style="margin: 3px;">
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="10">
                          <hr/>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <hr>
                </b-card-body>
              </b-collapse>

              <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
                <b-row style="background-color: #eeffed; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_ethics_committee_information'">
                  <b-col sm="12" lg="8">
                    <h6>
                      <i class="fa fa-cogs"></i>
                      <strong>
                        {{ StoreLangTranslation.data['ethics_committee_information'][StoreLang] }}
                      </strong>
                      <strong>
                        
                      </strong>
                    </h6>
                  </b-col>
                  <b-col sm="12" lg="4" style="text-align: right;"></b-col>
                </b-row>
              </b-card-header>
              <b-collapse id="id_ethics_committee_information">
                <b-card-body>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['53']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-form-textarea type="text" v-model="d_userShopBundleData.ethics_committee_approval_institution[lang.label]"></b-form-textarea>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['54']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-input type="date" v-model="d_userShopBundleData.ethics_committee_date"></b-form-input>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['55']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <b-form-input type="text" v-model="d_userShopBundleData.ethics_committee_protocol_number"></b-form-input>
                    </b-col>
                  </b-row>
                  <hr>
                </b-card-body>
              </b-collapse>

            </template>
          </b-card-body>
        </b-collapse>

        <b-card-header header-bg-variant="white" header-text-variant="dark" style="margin-bottom: 10px;">
          <b-row style="background-color: #edfcff; box-shadow: -3px -3px 10px 2px #d7edf9; padding: 10px;" v-b-toggle="'id_new_feature'">
            <b-col sm="12" lg="8">
              <h6>
                <i class="fa fa-cogs"></i>
                    <strong>
                  {{ StoreLangTranslation.data['new_feature'][StoreLang] }}
                    </strong>
              </h6>
            </b-col>
            <b-col sm="12" lg="4" style="text-align: right;"></b-col>
          </b-row>
        </b-card-header>
        <b-collapse id="id_new_feature">
          <b-card style="min-height: 300px;">
            <b-row style="margin: 3px;">
              <b-col sm="12" lg="6">
              </b-col>
              <b-col sm="12" lg="6" style="text-align: right;">
                <b-button variant="outline-success" @click="f_addNewFeatureItem()">
                  <i class="fa fa-plus-circle"></i>
                    {{ StoreLangTranslation.data['new_feature'][StoreLang] }}

                </b-button>
              </b-col>
            </b-row>
            
            <template v-if="d_userShopBundleData.feature.length > 0">
              <b-row v-for="(feature, feature_index) in d_userShopBundleData.feature" :style="f_calculateFeatureItemStyle(feature_index)">
                <b-col sm="12" lg="12">
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="10">
                      <strong>{{ feature_index + 1 }} )</strong>
                    </b-col>
                    <b-col sm="12" lg="2">
                      <b-button variant="danger" @click="f_deleteFeatureItem(feature_index)">
                        {{ StoreLangTranslation.data['delete'][StoreLang] }}
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['2']['parameters']['11']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <select class="form-control" v-model="feature.feature_type">
                        <option v-for="(op, op_index) in d_userShopBundleWdm['0']['parameters']['2']['parameters']['11'].options" :value="op.value">
                          {{ op.translation[StoreLang] }}
                        </option>
                      </select>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row style="margin: 3px;">
                    <b-col sm="12" lg="4">
                      <strong>{{ d_userShopBundleWdm['0']['parameters']['2']['parameters']['3']['name']['translation'][StoreLang] }}</strong>
                    </b-col>
                    <b-col sm="12" lg="8">
                    </b-col>
                  </b-row>
                  <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
                    <b-col sm="12" lg="1">
                      {{ lang.label }}
                    </b-col>
                    <b-col sm="12" lg="11">
                      <b-form-textarea class="form-control" rows="5" v-model="feature.feature_caption[lang.label]"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-collapse>

      
      </b-col>
    </b-row>

    <b-modal v-model="d_showAuthorEditModal" id="author-edit-modal" :title="StoreLangTranslation.data['author_edit'][StoreLang]" hide-footer size="xl">
      <div v-if="d_userShopBundleWdm">
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['60']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input
              class="form-control"
              v-model="d_authorData.title">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['58']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input
              class="form-control"
              v-model="d_authorData.firstname">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['59']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input
              class="form-control"
              v-model="d_authorData.lastname">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>old mail</strong>
          </b-col>
          <b-col sm="12" lg="8" disabled>
            {{ d_authorOldMail }}
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['61']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input
              class="form-control"
              v-model="d_authorData.mail">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['62']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea type="text" v-model="d_authorData.institution[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userShopBundleWdm['0']['parameters']['57']['parameters']['63']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input
              class="form-control"
              v-model="d_authorData.orcid_id">
            </b-form-input>
          </b-col>
        </b-row>
        

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="12">
            <template v-if="d_authorUpdateLoading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <b-button variant="outline-success" @click="f_changeAuthorData()">
                {{ StoreLangTranslation.data['save'][StoreLang] }}
              </b-button>
            </template>
          </b-col>
        </b-row>
      
      </div>
    </b-modal>

  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
import { mapGetters } from 'vuex';
export default {
  name: 'ShopBundleRecord',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    HtmlEditor,
  },
  props: {
    p_userShopClientID: {
      type: String,
      required: true
    },
    p_userShopBundleClientID: {
      type: String,
      required: true
    },
    f_userShopBundleList: {
      type: Function,
      required: true
    },
  },
  data () {
    return {
      d_userShopBundleWdmrId: '',
      d_userShopBundleLayerId: '',
      d_authorSearchLoading: false,
      d_searchAuthorMails: '',
      d_saveLoading: false,
      d_loading: false,
      d_user: '',
      d_frontendClientID: '',
      d_userShopClientID: '',
      d_userShopBundleClientID: '',
      d_frontendPackageGroupList: [],
      d_userShopBundleWdm: '',
      d_userShopBundleData: {
        'status': '0',
        'bundle_name': {},
        'bundle_group': {},
        'organization_id': {},
        'organization_name': {},
        'organization_user_id': {},
        'organization_username': {},
        'priority': '0',
        'task_type': '2',
        'feature': [],
        'available_soon': '1',
        'prices_on_the_screen': '0',
        'in_store_visibility': '1',
        'can_customer_add_to_shopcart': '1',
        'expiration_time_type': '2',
        'expiration_time_value': {},
        'expiration_time_value_by_text': {},
        'organization_token': {},
        'bundle_type': '0',
        'ordered_use': '1',
        'assigned_user_list': {},
        'max_assigned_count': '',
        'used_assigned_count': '',
        'package_creator_user': '',
        'dataset_creator_note': '',
        'communication_with_the_user_requesting_the_dataset': '',
        'dataset_creator_phone': '',
        'dataset_creator_mail': '',
        'dataset_creator_note_to_requester': {},
        'reason_for_cancellation': '',
        'reason_for_cancellation_note': '',
        'special_acknowledgement_request_status': '',
        'special_acknowledgement_text': '',
        'demo_dataset': '',
        'row_count': '',
        'column_count': '',
        'various_variables': '',
        'about_dataset': '',
        'dataset_usage_type': '',
        'methodologies_and_analyses_to_be_excluded': '',
        'data_collection_center_count': '',
        'data_collection_centers': '',
        'licence_type': '',
        'dataset_publication_status_in_an_article': '',
        'journal_name': '',
        'article_title': '',
        'link': '',
        'which_one_best_describes_your_reason_for_sharing_dataset': '',
        'visiting_research_institution_request_text': {},
        'ethics_committee_approval_institution': {},
        'ethics_committee_date': '',
        'ethics_committee_protocol_number': '',
        'is_dataset': '',
        'author_list': [],
        'article_list': [],
        'bundle_date': '',
        'institutional_number_per_user': '',
      },
      ClsUser: ClsUser,
      d_bundleHasAgreementList: [],
      d_selectedAgreementCopy: '',
      d_agreementListLoading: false,
      d_selectBundleGroup: '',
      d_shopBundleGroupList: [],
      d_PackageGroupFrontendList: {},
      d_inputEditorMode: 'html',
      d_htmlParameters: [
        'about_dataset',
        'various_variables',
      ],
      d_authorData: {
        'firstname': '',
        'lastname': '',
        'title': '',
        'mail': '',
        'institution': {
          'tr': '',
          'en': '',
        },
        'orcid_id': '',
      },
      d_authorOldMail: '',
      d_showAuthorEditModal: false,
      d_authorUpdateLoading: false,
    };
  },
  created: function () {
    this.d_loading = true;
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.p_userShopClientID
    this.d_userShopBundleClientID = this.p_userShopBundleClientID
    // if (this.$route.query.user_shop_client_id) {
    //   this.d_userShopClientID = this.$route.query.user_shop_client_id;
    // }

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      if (this.d_userShopClientID) {
        // if (this.$route.query.user_shop_bundle_client_id) {
        //   this.d_userShopBundleClientID = this.$route.query.user_shop_bundle_client_id;
        //   this.f_userShopBundleGet();
        // }
        if (this.d_userShopBundleClientID) {
          this.f_userShopBundleGet(); 
        }
      } else {
        alert(this.StoreLangTranslation.data['shop_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      if (!this.d_userShopBundleClientID) {
        this.f_langEligibleParameterProcess();
        this.d_loading = false;
      }
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
    this.f_getBundleHasAgreementList();
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {
    f_moveResearcher: function (index, direction) {
      if (direction === 'up') {
        if (index === 0) {
          return
        }
        let up_researcher = JSON.parse(JSON.stringify(this.d_userShopBundleData.author_list[index - 1]))
        this.d_userShopBundleData.author_list[index - 1] = JSON.parse(JSON.stringify(this.d_userShopBundleData.author_list[index]))
        this.d_userShopBundleData.author_list[index] = up_researcher
      } else if (direction === 'down') {
        if (index === this.d_userShopBundleData.author_list.length - 1) {
          return
        }
        let up_researcher = JSON.parse(JSON.stringify(this.d_userShopBundleData.author_list[index]))
        this.d_userShopBundleData.author_list[index] = JSON.parse(JSON.stringify(this.d_userShopBundleData.author_list[index + 1]))
        this.d_userShopBundleData.author_list[index + 1] = up_researcher
      }
      this.$forceUpdate();
    },

    f_moveArticleAuthor: function (article_index, article_author_index, direction) {
      if (direction === 'up') {
        if (article_author_index === 0) {
          return
        }
        let up_researcher = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index - 1]))
        this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index - 1] = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index]))
        this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index] = up_researcher
      } else if (direction === 'down') {
        if (article_author_index === this.d_userShopBundleData.article_list[article_index].article_authors.length - 1) {
          return
        }
        let up_researcher = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index]))
        this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index] = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index + 1]))
        this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index + 1] = up_researcher
      }
      this.$forceUpdate();
    },

    f_copyResearcher: function (index) {
      let copy_researcher = JSON.parse(JSON.stringify(this.d_userShopBundleData.author_list[index]))
      this.d_userShopBundleData.author_list.push(copy_researcher);
    },
    f_copyArticleAuthor: function (article_index, article_author_index) {
      let copy_article_author = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[article_index].article_authors[article_author_index]))
      this.d_userShopBundleData.article_list[article_index].article_authors.push(copy_article_author);
    },
    f_copyArticle(index) {
      let copy_article = JSON.parse(JSON.stringify(this.d_userShopBundleData.article_list[index]))
      this.d_userShopBundleData.article_list.push(copy_article);
    },
    f_changeAuthorData: function () {
      if (this.d_authorOldMail) {
        let query = 'mail=' + this.d_authorOldMail;
        let data = {
          'new_data': this.d_authorData
        };
        this.d_authorUpdateLoading = true;
        ServiceFunctions.single_author_update_for_all_bundles(query, data)
          .then(resp => {
            this.d_authorUpdateLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              for (let author of this.d_userShopBundleData.author_list) {
                if (author.mail == this.d_authorOldMail) {
                    author.firstname = this.d_authorData.firstname;
                    author.lastname = this.d_authorData.lastname;
                    author.title = this.d_authorData.title;
                    author.mail = this.d_authorData.mail;
                    author.institution = this.d_authorData.institution;
                    author.orcid_id = this.d_authorData.orcid_id;
                  }
              }

              for (let article of this.d_userShopBundleData.article_list) {
                for (let author of article.article_authors) {
                  if (author.mail == this.d_authorOldMail) {
                    author.firstname = this.d_authorData.firstname;
                    author.lastname = this.d_authorData.lastname;
                    author.title = this.d_authorData.title;
                    author.mail = this.d_authorData.mail;
                    author.institution = this.d_authorData.institution;
                    author.orcid_id = this.d_authorData.orcid_id;
                  }
                }
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_openAuthorEditModal: function (author_data) {
      if (author_data.mail) {
        this.d_authorOldMail = author_data.mail
        this.d_authorData = {
          'firstname': '',
          'lastname': '',
          'title': '',
          'mail': author_data.mail,
          'institution': {
            'tr': '',
            'en': '',
          },
          'orcid_id': '',
        };
        // console.log(author_data)
        try {
          this.d_authorData.firstname = author_data.firstname;
        } catch {}
        try {
          this.d_authorData.lastname = author_data.lastname;
        } catch {}
        try {
          this.d_authorData.title = author_data.title;
        } catch {}
        try {
          this.d_authorData.institution = JSON.parse(JSON.stringify(author_data.institution));
        } catch {}
        try {
          this.d_authorData.orcid_id = author_data.orcid_id;
        } catch {}

        this.d_showAuthorEditModal = true;
      }
      
    },
    f_domainGet: function () {
      let location_url = window.location.host;
      // console.log('location_url    : ', location_url);
      try {
        location_url = location_url.replace(/^www\./g, "");
      } catch (err) {}
      // console.log('location_url : ', location_url)
      return location_url;
    },
    f_authorSearchByMailAndAdd: function(insert_data){
      // console.log(this.d_selectedAgreementCopy);
      let query = 'user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {
        'author_mails': this.d_searchAuthorMails.replace(' ', '').split(',')
      };
      this.d_authorSearchLoading = true;
      ServiceFunctions.user_shop_bundle_author_search(query, data)
        .then(resp => {
          this.d_authorSearchLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list && resp.data.list.length > 0) {
              for (let i in resp.data.list) {
                insert_data.push(resp.data.list[i]);
              }
              this.$forceUpdate();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_changeInputEditorMode: function(editor_mode, param_location){
      if(editor_mode == "text"){
        for (let lang of this.StoreLangList.data) {
          for (let html_param of this.d_htmlParameters) {
            let div_el = document.getElementById("website_html_edit_" + html_param + '_' + lang.label);
            param_location[html_param][lang.label] = div_el.innerHTML;
          }
        }
      }
      setTimeout(function () {
        this.d_inputEditorMode = editor_mode;
      }.bind(this), 50);
    },
    f_addArticleAuthor(article_index) {
      this.d_userShopBundleData.article_list[article_index].article_authors.push({
        'firstname': "",
        'lastname': "",
        'title': "",
        'mail': "",
        'institution': {
          'tr': '',
          'en': '',
        },
        'orcid_id': "",
      });
    },
    f_removeArticleAuthor(article_index, article_author_index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_userShopBundleData.article_list[article_index].article_authors.splice(article_author_index, 1);
      }
    },
    f_addArticle() {
      this.d_userShopBundleData.article_list.push({
        'article_status': '0',
        'journal_name': '',
        'article_title': '',
        'article_link': '',
        'article_date': '',
        'article_authors': [],
        'article_creator': "",
        'research_methodology': "",
      });
    },
    f_removeArticle(index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_userShopBundleData.article_list.splice(index, 1);
      }
    },
    f_addResearcher() {
      this.d_userShopBundleData.author_list.push({
        'firstname': "",
        'lastname': "",
        'title': "",
        'mail': "",
        'institution': {
          'tr': '',
          'en': '',
        },
        'orcid_id': "",
      });
    },
    f_removeResearcher(index) {
      if (confirm(this.StoreLangTranslation.data['delete_confirm'][this.StoreLang])) {
        this.d_userShopBundleData.author_list.splice(index, 1);
      }
    },
    f_getPackageGroupFrontendList: function () {
      // console.log("aaaaaaaa")
      // console.log(this.d_PackageGroupFrontendList)
      // this.d_PackageGroupFrontendList[]
      // this.$forceUpdate();
      if (this.d_selectBundleGroup && this.d_selectBundleGroup.val) {
        for (let index in this.d_frontendPackageGroupList) {
          if (this.d_frontendPackageGroupList[index].package_groups_to_show_in_shop) {
            let arr = this.d_frontendPackageGroupList[index].package_groups_to_show_in_shop.split(',').map(item => item.trim());
            if (arr.includes(this.d_selectBundleGroup.val)) {
              this.d_PackageGroupFrontendList[this.d_frontendPackageGroupList[index].client_id] = true;
            } else {
              this.d_PackageGroupFrontendList[this.d_frontendPackageGroupList[index].client_id] = false;
            }
            
          }
        }
      }
      this.$forceUpdate();
    },
    f_copyAgreement: function () {
      // console.log(this.d_selectedAgreementCopy);
      let query = 'user_shop_client_id=' + this.d_userShopClientID;
      if (this.d_userShopBundleClientID) {
        query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      }
      if (this.d_selectedAgreementCopy) {
        query += '&copy_user_shop_bundle_client_id=' + this.d_selectedAgreementCopy;
      }
      let data = {};
      this.d_agreementListLoading = true;
      ServiceFunctions.user_shop_bundle_agreement_copy(query, data)
        .then(resp => {
          this.d_agreementListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list && resp.data.list.length > 0) {
              this.d_bundleHasAgreementList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getBundleHasAgreementList: function () {
      let query = '';
      let data = {};
      this.d_agreementListLoading = true;
      ServiceFunctions.bundle_has_agreement_list(query, data)
        .then(resp => {
          this.d_agreementListLoading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list && resp.data.list.length > 0) {
              this.d_bundleHasAgreementList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_deleteFeatureItem: function (feature_index) {
      this.d_userShopBundleData.feature.splice(feature_index, 1);
    },
    f_addNewFeatureItem: function () {
      let lang_eligible_variables = ['feature_caption'];
      let new_feature_item = { 'feature_caption': {}, 'feature_type': '' };
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          new_feature_item[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
        }
      }
      this.d_userShopBundleData.feature.push(new_feature_item);
    },
    f_calculateFeatureItemStyle: function (feature_index) {
      let style = 'margin: 3px;';
      if (feature_index % 2 === 0) {
        style += 'background-color: #99e4e8';
      } else {
        style += 'background-color: #99e4e8';
        // style += 'background-color: white;';
      }
      return style;
    },
    f_goToShopList: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_list'), query: {} });
    },
    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['bundle_name', 'organization_id', 'organization_name', 'organization_user_id', 'organization_username', 'expiration_time_value', 'expiration_time_value_by_text', 'organization_token', 'assigned_user_list', 'special_acknowledgement_text', 'various_variables', 'about_dataset', 'methodologies_and_analyses_to_be_excluded', 'dataset_creator_note_to_requester', 'data_collection_centers'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          try {
            if (!this.d_userShopBundleData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
              this.d_userShopBundleData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
            }

          } catch {
            console.log(lang_eligible_variables[k])
          }
        }
      }
    },
    f_userShopBundleRecord: function () {

      try {
        if(this.d_inputEditorMode == 'html'){
          for (let lang of this.StoreLangList.data) {
            for (let html_param of this.d_htmlParameters) {
              let div_el = document.getElementById("website_html_edit_" + html_param + '_' + lang.label);
              this.d_userShopBundleData[html_param][lang.label] = div_el.innerHTML;
            }
          }
        }
      } catch {}
      let query = 'user_client_id=' + this.d_user.username;
      let data = {'package_group_frontend_list': ''};
      if (this.d_userShopBundleClientID) {
        query += '&user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      }
      if (this.d_userShopClientID) {
        query += '&user_shop_client_id=' + this.d_userShopClientID;
      }
      for (let i in this.d_userShopBundleData) {
        data[i] = this.d_userShopBundleData[i];
      }
      let tempFrontendGroupList = {};
      for (let i in this.d_PackageGroupFrontendList) {
        if (this.d_PackageGroupFrontendList[i]) {
          tempFrontendGroupList[i] = '1';
        } else {
          tempFrontendGroupList[i] = '0';
        }
      }
      data.package_group_frontend_list = tempFrontendGroupList;
      // console.log(data.package_group_frontend_list);
      this.d_saveLoading = true;
      if (this.d_userShopBundleClientID) {
        ServiceFunctions.user_shop_bundle_edit(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      } else {
        ServiceFunctions.user_shop_bundle_new(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              this.f_userShopBundleList();
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_userShopBundleGet: function (user_shop_bundle_client_id) {
      this.d_loading = true;
      let query = 'user_shop_bundle_client_id=' + this.d_userShopBundleClientID;
      query += '&data_type=value_mode';
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shop_bundle_get(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userShopBundleWdmrId = resp.data.wdmr_id;
              this.d_userShopBundleLayerId = resp.data.layer_id;
              this.d_userShopBundleData = resp.data.data;
              this.d_frontendPackageGroupList = resp.data.frontend_package_group_list;
              this.d_shopBundleGroupList = resp.data.shop_package_group_list;
              this.f_langEligibleParameterProcess();
              for (let i in this.d_frontendPackageGroupList) {
                this.d_PackageGroupFrontendList[this.d_frontendPackageGroupList[i].client_id] = false;
              }
              let lang_list = []
              for (let langKey in this.d_userShopBundleData.bundle_group) {
                lang_list.push(langKey);
              }
              for (let bundle_grp_item of this.d_shopBundleGroupList) {
                let equal = true;
                for (let lang_item of lang_list) {
                  if (bundle_grp_item['lang'][lang_item] !== this.d_userShopBundleData.bundle_group[lang_item]) {
                    equal = false;
                    break;
                  }
                }
                if (equal) {
                  this.d_selectBundleGroup = {'val': this.d_userShopBundleData.bundle_group.en, 'lang': this.d_userShopBundleData.bundle_group}
                  this.f_getPackageGroupFrontendList();
                  break;
                }
              }

            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {
    'd_userShopBundleData.ordered_use': function() {
      if (this.d_userShopBundleData.ordered_use == '0') {
        this.d_userShopBundleData.prices_on_the_screen = '0';
        this.d_userShopBundleData.can_customer_add_to_shopcart = '1';
      }
    },
    'd_selectBundleGroup': function () {
      this.d_userShopBundleData.bundle_group = JSON.parse(JSON.stringify(this.d_selectBundleGroup.lang))
    }
  }
};

</script>

